import React from 'react';
import Layout from "../../components/Layout";
import UploadDocuments from "../../components/uploadDocuments/uploadDocuments";

const Index = () => {
  return (
    <Layout>
      <div className={"my-container px-5"}>
        <div className={" mt-14"}>
          <UploadDocuments/>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
